import type { IAppRoute } from '@app/layouts/user'
import Clinic from '@app/screens/clinic/clinic'

import { AccountSettingsScreen } from './settings'

export const routes: IAppRoute[] = [
  {
    component: Clinic,
    exact: true,
    label: 'Return to Clinic',
    path: '/clinic/today',
    title: 'Return to Clinic',
  },
  {
    component: AccountSettingsScreen,
    exact: true,
    label: 'Settings',
    path: '/account/settings',
    title: 'Account Settings',
  },
]
